import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setOptInStatus } from 'client/actions/userActions'
import { klubbleAPI } from 'client/api/common'

type OptinStatus = {
  newsletterOptIn: boolean
  weeklyStatsOptIn: boolean
}

export const useFetchOptinStatus = () => {
  const dispatch = useDispatch()
  const [optinStatusFetched, setOptinStatusFetched] = useState(false)

  useEffect(() => {
    const abortController = new AbortController()

    const fetchOptinStatus = async () => {
      try {
        const res = await klubbleAPI.get<OptinStatus>('Auth/getOptInStatus', {
          signal: abortController?.signal,
        })
        if (res.data) {
          await setOptInStatus(res.data.newsletterOptIn, res.data.weeklyStatsOptIn)(dispatch)
        }
      } finally {
        setOptinStatusFetched(true)
      }
    }

    if (!optinStatusFetched) {
      fetchOptinStatus()
    }
    return () => {
      abortController.abort()
    }
  }, [optinStatusFetched, dispatch])

  return optinStatusFetched
}
